import { Suspense, lazy } from "react";
import FancyLoader from "../Components/Loader/FancyLoader";
import SectionDivider from "../Components/Animations/SectionDivider";
import AboutIntro from "../Components/Animations/AboutIntro";

// Lazy-loaded components
const Navbar = lazy(() => import("../Components/Navbar/Navbar"));
const Dedication = lazy(() => import("../Components/Dedication/Dedication"));
const CoreComponent = lazy(() => import("../Components/CoreComponent/CoreComponent"));
const TeamUp = lazy(() => import("../Components/TeamUp/TeamUp"));
const Footer = lazy(() => import("../Components/Footer/Footer"));

const AboutUs = () => {
  return (
    <Suspense fallback={<FancyLoader />}>
      <Navbar />

     <br></br>
     <br></br>
     <br></br>
        {/* Animated intro section with welcome message */}
        <AboutIntro />
      {/* Dedicated mission/vision content */}
      <Dedication />

      {/* Visual break with animated divider */}
      <SectionDivider
        icon="rocket"
        title="Boost Your Monetization"
        description="Next-level ad strategies and global expansion awaits."
      />

      {/* Core company values / features */}
      <CoreComponent />

      {/* Call to action or partnership section */}
      <TeamUp />

      <Footer />
    </Suspense>
  );
};

export default AboutUs;
